import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const OverviewPanel = () => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" alignItems="center" spacing={3}>
        <Box
          component="img"
          src="/kailog-talk_icon_512.png"
          alt={t("app.name")}
          sx={{
            width: 120,
            height: 120,
            objectFit: "contain",
          }}
        />
        <Typography variant="h4" component="h1" fontWeight="bold">
          {t("app.name")}
        </Typography>
      </Stack>
      <Typography variant="body1" gutterBottom>
        {t("home.app_description")}
      </Typography>
    </Stack>
  );
};

export default OverviewPanel;
